<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <section class="section is-main-section">
      <card-component
        :title="formCardTitle"
        icon="file-edit"
        class="tile is-child"
      >
        <volunteer-activity-add
          @handleAddVolunteerActivity="handleAddVolunteerActivity"
          @handleEditVolunteerActivity="handleEditVolunteerActivity"
        />
      </card-component>
    </section>
  </div>
</template>

<script>
import TitleBar from "../components/TitleBar.vue";
import CardComponent from "@/components/CardComponent";
import { pathOr } from "ramda";
import Volunteering from "../services/volunteering.service";
import { notify } from "@/helpers/notify";
import VolunteerActivityAdd from "../components/volunteering/volunteers/volunteerActivity-add.vue";

export default {
  components: { TitleBar, CardComponent, VolunteerActivityAdd },
  name: "VolunteerActiviy",
  data() {
    return {
      volunteer: {},
      volunteerId: 0,
      editMode: false,
    };
  },
  computed: {
    titleStack() {
      const root = { label: "Registru Voluntariat", to: "/Volunteering" };
      const volunteerName = {
        label: `${this.volunteer.firstName} ${this.volunteer.lastName}`,
        to: `/volunteers/${this.volunteerId}/activities`,
      };
      if (this.editMode) {
        return [root, volunteerName, "Editare activitate"];
      } else {
        return [root, volunteerName, "Adaugare activitate"];
      }
    },
    formCardTitle() {
      if (this.editMode) {
        return "Editare activitate";
      } else {
        return "Adaugare activitate";
      }
    },
  },
  methods: {
    async handleAddVolunteerActivity(volunteerActivity) {
      try {
        const { addVolunteerActivity } = Volunteering;
        const response = await addVolunteerActivity(volunteerActivity);
        const { data, status } = response;
        if (status == "200") {
          notify.success(this, "Activitatea a fost adaugata.");
          this.$router.push({ path: `/Volunteering` });
        } else {
          notify.error(this, "Eroare la adaugarea activitatii.");
        }
      } catch (error) {
        notify.error(this);
      }
    },
    async handleEditVolunteerActivity(volunteerActivity) {
      try {
        const { editVolunteerActivity } = Volunteering;
        const response = await editVolunteerActivity(volunteerActivity);
        const { data, status } = response;
        if (status == "200") {
          notify.success(this, "Activitatea a fost modificata.");
          this.$router.push({ path: `/Volunteering` });
        } else {
          notify.error(this, "Eroare la modificarea activitatii.");
        }
      } catch (error) {
        notify.error(this);
      }
    },
    async getVolunteer(id) {
      const { getVolunteer } = Volunteering;
      const response = await getVolunteer(id);
      const { data } = response;
      this.volunteer = data;
    },
  },
  created() {
    const id = parseInt(pathOr(null, ["params", "id"], this?.$route));
    const volunteerId = parseInt(
      pathOr(null, ["params", "volunteerId"], this?.$route)
    );

    this.volunteerId = volunteerId;
    this.getVolunteer(this.volunteerId);

    if (id) {
      this.editMode = true;
    } else {
      this.editMode = false;
    }
  },
};
</script>

<style></style>
